import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=6b078dae&scoped=true&"
import script from "./DocumentDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetail.vue?vue&type=style&index=0&id=6b078dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b078dae",
  null
  
)

export default component.exports